import React from 'react'

function OurServices() {
  return (
    <section class="wrapper custom-wrapper top-services">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="block-title">Our Services</h2>
                    <p class="text-300">We provide reliable Application Development and maintenance services to help client to meet their strategic business objectives and fulfill their goals. We cover the various areas of Web Development , Designing, E-commerce ,Application , SEO Services .  We have proven and highly appreciable track record in development, designing, managing and transforming applications for a wide range of clients</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-hidden"></div>
                <div class="col-md-4 col-sm-6">
                    <ul class="list-unstyled services-list our-services">
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div class="hvr-pulse" data-icon="&#xe00e;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Web Designing</h3>
                            <p>We have been offering the best web Design Services and building best quality application solutions</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div class="hvr-pulse" data-icon="&#xe07a;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>E-commerce Solutions</h3>
                            <p>We offers the most quality based, Customer oriented, user friendly E-Commerce Website in today's market</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div class="hvr-pulse" data-icon="&#xe0f7;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>SEO Service</h3>
                            <p>which can gain a large amount of visitors to increase online business</p>
                        </div>
                    </li>
                    </ul>
                </div>
                <div class="col-md-4 col-sm-6">
                    <ul class="list-unstyled services-list our-services">
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div class="hvr-pulse" data-icon="&#xe038;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Web Development</h3>
                            <p>Our development cover stages of planning, strategy, research, immense level of testing & on-time delivery</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div class="hvr-pulse" data-icon="&#xe00b;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Mobile App Development</h3>
                            <p>We provide the best quality and user friendly Android/IOS/Windows Application with latest Technology</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div class="hvr-pulse" data-icon="&#xe035;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Testing and Support</h3>
                            <p>we give best support service with quality testing to your business too meet high end applications</p>
                        </div>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="side-image our-services-img"><img class="img-responsive" alt="" src="assets/images/side-img-2.png" /> </div>
    </section>
  )
}

export default OurServices